/* eslint-disable eqeqeq */
import BaseComponent from 'scripts/BaseComponent.js';
import Cart from '../cart';

export default class MiniCartGwp extends BaseComponent {
  constructor(component) {
    super(component);
    this.debug = false;

    this.refs = {
      gwpId: '.js-gwpId',
      giftId: '.js-giftId',
      giftAvailable: '.js-giftAvailable',
      giftParameterNote: '.js-giftParameterNote',
      cartItem: '.CartItem',
    };

    this.dom = {
      $component: component,
      $gwpId: this.$get(this.refs.gwpId),
      $giftId: this.$get(this.refs.giftId),
      $giftAvailable: this.$get(this.refs.giftAvailable),
      $giftParameterNote: this.$get(this.refs.giftParameterNote),
      $cartItems: this.$getAll(this.refs.cartItem),
    };

    this.state = {
      mountCartItemsEvent: 'mountcartitems',
      collectionProductData: {},
      gwpId: '',
      giftData: {},
    };

    this.mount();
    this.init();
  }

  mount() {
    const { state } = this;
    super.mount();

    this.setOnCustomEvent(state.mountCartItemsEvent, this.updateGWP);
  }

  init() {
    this.getId();
    this.parseGiftData();
    this.updateGWP();
  }

  getId() {
    const { dom, state } = this;
    state.gwpId = dom.$gwpId.innerHTML.replace(/[\r\n\s$,+]/gm, '');
  }

  parseGiftData() {
    const { dom, state } = this;
    state.giftData = {
      id: dom.$giftId.innerHTML.replace(/[\r\n\s$,+]/gm, ''),
      available: dom.$giftAvailable.innerHTML.includes('true'),
      parameterNote: dom.$giftParameterNote.innerHTML,
    };
  }

  cartQualifies() {
    const { state } = this;
    const cartItems = document.querySelectorAll('.CartItem');

    const qualifyingItems = Array.from(cartItems).filter((item) => {
      const { gwpQualifier } = item.dataset;
      return gwpQualifier && gwpQualifier.includes(state.gwpId);
    });

    return qualifyingItems.length > 0;
  }

  updateGWP() {
    const { dom, state } = this;
    const cartItems = document.querySelectorAll('.CartItem');
    const cartQualifying = this.cartQualifies();
    const parameters = {
      _gwp_id: state.gwpId,
    };
    let giftKey = null;

    if (!state.giftData.available) {
      return;
    }

    cartItems.forEach((item) => {
      const { id, key } = item.dataset;

      if (`${id}` === state.giftData.id) {
        giftKey = key;
      }
    });

    if (cartQualifying) {
      dom.$component.classList.remove('hide');
      if (giftKey === null) {
        if (!state.giftData.parameterNote.includes('false')) {
          parameters.Note = state.giftData.parameterNote;
        }

        Cart.addItem(state.giftData.id, parameters, 1, false);
      }
    } else {
      dom.$component.classList.add('hide');
      if (giftKey) {
        Cart.updateItem(giftKey, 0);
      }
    }
  }
}
